module.exports = __webpack_public_path__ + "static/maroc-90416b317615471d941f985433b5e0e3.jpg";